import FormattedMessage from 'I18n/components/FormattedMessage';
import { findValidI18nKey, getI18nText } from 'pricing-pages-lib/utils/languageUtils';
import { BREEZE_INTELLIGENCE_CREDITS_100, BREEZE_INTELLIGENCE_CREDITS_1000, BREEZE_INTELLIGENCE_CREDITS_10000, BREEZE_INTELLIGENCE_CREDITS_10000_COMMITTED, BREEZE_INTELLIGENCE_CREDITS_1000_COMMITTED, BREEZE_INTELLIGENCE_CREDITS_100_COMMITTED } from 'self-service-api/constants/ApiNames';
import { FeaturesLayoutUI } from './FeaturesLayoutUI';
import { PriorityFeatures } from './PriorityFeatures';
import { jsx as _jsx } from "react/jsx-runtime";
const SMALL = 'SMALL';
const MEDIUM = 'MEDIUM';
const LARGE = 'LARGE';
const getBreezePackSize = apiName => {
  switch (apiName) {
    case BREEZE_INTELLIGENCE_CREDITS_100:
    case BREEZE_INTELLIGENCE_CREDITS_100_COMMITTED:
      return SMALL;
    case BREEZE_INTELLIGENCE_CREDITS_1000:
    case BREEZE_INTELLIGENCE_CREDITS_1000_COMMITTED:
      return MEDIUM;
    case BREEZE_INTELLIGENCE_CREDITS_10000:
    case BREEZE_INTELLIGENCE_CREDITS_10000_COMMITTED:
      return LARGE;
    default:
      return null;
  }
};
const allPriorityFeatures = [{
  shortName: 'credits',
  packs: [SMALL, MEDIUM, LARGE]
}, {
  shortName: 'enrichment',
  packs: [SMALL, MEDIUM, LARGE]
}, {
  shortName: 'formShortening',
  packs: [SMALL, MEDIUM, LARGE]
}, {
  shortName: 'dataTest',
  packs: [SMALL, MEDIUM, LARGE]
}, {
  shortName: 'buyerIntent',
  packs: [SMALL, MEDIUM, LARGE]
}, {
  shortName: 'conversationalEnrichment',
  packs: [SMALL, MEDIUM, LARGE]
}, {
  shortName: 'smartProperties',
  packs: [SMALL, MEDIUM, LARGE]
}, {
  shortName: 'continuousDataEnrichment',
  packs: [MEDIUM, LARGE]
}, {
  shortName: 'jobChangeAlerts',
  packs: [MEDIUM, LARGE]
}, {
  shortName: 'outOfOfficeDetection',
  packs: [MEDIUM, LARGE]
}, {
  shortName: 'researchIntent',
  packs: [LARGE]
}];
const getFeatures = apiName => {
  const size = getBreezePackSize(apiName);
  if (!size) {
    return [];
  }
  return allPriorityFeatures.reduce((acc, priorityFeature) => {
    const shortName = priorityFeature.shortName;
    const nameKey = findValidI18nKey([`merchCards.breezeTile.priorityFeatures.features.${shortName}.name.${size}`, `merchCards.breezeTile.priorityFeatures.features.${shortName}.name`, `merchCards.breezeTile.priorityFeatures.features.${shortName}.name.default`]);
    acc.push({
      shortName,
      description: getI18nText(`merchCards.breezeTile.priorityFeatures.features.${shortName}.description`),
      displayName: nameKey ? getI18nText(nameKey) : '',
      isAvailable: priorityFeature.packs.includes(size)
    });
    return acc;
  }, []);
};
export const LegacyBreezeFeatures = ({
  apiName
}) => {
  const features = getFeatures(apiName);
  const HeaderSection = /*#__PURE__*/_jsx(FormattedMessage, {
    message: `merchCards.breezeTile.priorityFeatures.includes`
  });
  const FeaturesListSection = /*#__PURE__*/_jsx(PriorityFeatures, {
    features: features
  });

  // TODO - add skeleton loader when move breeze business obj to feature store
  return /*#__PURE__*/_jsx(FeaturesLayoutUI, {
    loading: false,
    HeaderSection: HeaderSection,
    FeaturesListSection: FeaturesListSection
  });
};